import { getGroupsWithPropertiesFetchUrl, makeGroupsWithPropertiesQuickFetchKey } from './cacheKeys';
import { withQuickFetch } from './withQuickFetch';
export const fetchGroupedProperties = ({
  httpClient,
  frameworkTypeIdentifier,
  query
}) => withQuickFetch({
  requestName: makeGroupsWithPropertiesQuickFetchKey({
    frameworkTypeIdentifier,
    query
  }),
  baseFetch: () => httpClient.get(getGroupsWithPropertiesFetchUrl({
    frameworkTypeIdentifier,
    query
  }))
}).then(({
  results
}) => results);